




























































import { defineComponent, nextTick, ref } from '@nuxtjs/composition-api'
import { defineComponentTranslations } from '~/utils/i18n'
import XmlService from '~/services/XmlService'
import { useDep } from '~/compositions/dependency-container'
import CTextArea from '~/components/shared/configurable/form/input/CTextArea.vue'
import { useI18n } from '~/compositions/i18n'
import { useLogger } from '~/compositions/logger'
import { handleError } from '~/utils/http'
import { AxiosError } from 'axios'
import { useSnackbar } from '~/compositions/snackbar'
import { useWebSocket } from '~/compositions/web-socket'
import { toCamelCase } from '~/utils/object'

export default defineComponent({
  components: { CTextArea },
  setup() {
    const xmlService = useDep(XmlService)
    const snackbar = useSnackbar()
    const { t } = useI18n()
    const logger = useLogger()
    const { close, setUrl } = useWebSocket(null, {
      onMessage,
      onConnected
    })

    const status = ref('')
    const errors = ref([])
    const url = ref('')
    const relayUrl = ref('')
    const isLoading = ref(false)
    const percentage = ref(0)

    async function onConnected() {
      await xmlService.validateXml(url.value)
    }

    async function onMessage(_: WebSocket, event: MessageEvent) {
      const message = toCamelCase(JSON.parse(event.data))
      status.value = `${message.message}`
      percentage.value = Math.round((message.current / message.total) * 100)

      if (percentage.value === 100 && !message.errors?.length) {
        snackbar.success(t('no_errors'), { time: 10000 })
      }
      if (message.errors) {
        errors.value = message.errors
      }
      await nextTick()
      if (message.current === message.total) {
        isLoading.value = false
        close()
      }
    }

    async function onSubmit() {
      close()
      isLoading.value = true
      status.value = ''
      errors.value = []
      try {
        const data = await xmlService.fetchSocketUrl(url.value)
        relayUrl.value = data.relayUrl
        setUrl(relayUrl.value)
      } catch (e) {
        handleError(e as AxiosError, snackbar, logger, t)
        close()
        isLoading.value = false
      }
    }
    return {
      onSubmit,
      url,
      status,
      errors,
      isLoading,
      percentage
    }
  },

  i18n: defineComponentTranslations({
    xml_link: {
      en:
        'Below, you can enter the link to your XML to check if it is valid or not.',
      el:
        'Παρακάτω μπορείτε να εισάγετε το σύνδεσμο του XML σας για να δείτε αν είναι έγκυρο ή όχι.'
    },
    attention: {
      en:
        '<strong>CAUTION</strong>: You can check the same address only once per minute.',
      el:
        '<strong>ΠΡΟΣΟΧΗ</strong>: Μπορείτε να ελέγξετε την ίδια διεύθυνση μόνο μία φορά ανά 1 λεπτό.'
    },
    car_gr_reserves: {
      en:
        'Car.gr reserves the right to use the data of the advertisements submitted.',
      el:
        'Το car.gr διατηρεί το δικαίωμα χρήσης των δεδομένων των αγγελιών που καταχωρούνται.'
    },
    check: {
      en: 'Check',
      el: 'Έλεγχος'
    },
    enter_url: {
      en: 'Enter the URL from your XML',
      el: 'Εισάγετε το URL από το XML σας'
    },
    eg: {
      en: 'e.g.',
      el: 'π.χ.'
    },
    errors: {
      en: 'Errors',
      el: 'Σφάλματα'
    }
  })
})
